import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { DownloadIcon } from "~/components/ui/icons/download";
import { Loader } from "~/components/ui/loader";
import { toast } from "~/components/ui/toast";
import { useGenerateInvoiceCustomsMutation } from "~/graphql/graphql-new.gen";

type OrderInvoiceCustomsProps = {
  orderId: string;
};

const downloadURI = (uri: string) => {
  const link = document.createElement("a");
  // If you don't know the name or want to use
  // the webserver default set name = ''
  link.setAttribute("download", "download");
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const OrderInvoiceCustoms: React.FC<OrderInvoiceCustomsProps> = ({
  orderId,
}) => {
  const { t } = useTranslation();

  const { mutateAsync, isPending, error } = useGenerateInvoiceCustomsMutation();

  useEffect(() => {
    if (error) {
      toast.error(t("order.invoice_customs.generate_invoice_error"));
    }
  }, [error]);

  return (
    <div className="space-y-2">
      {isPending ? (
        <Loader className="size-4" />
      ) : (
        <button
          type="button"
          className="flex gap-x-1 text-xs font-semibold text-green-900"
          onClick={async () => {
            const { generateInvoiceCustoms } = await mutateAsync({
              orderId,
            });
            downloadURI(generateInvoiceCustoms.url);
          }}
        >
          <DownloadIcon className="size-4" />
          {t("order.invoice_customs.download_invoice")}
        </button>
      )}
      <p className="text-xs text-[#767A7C]">
        {t("order.invoice_customs.us_customs_procedures_only")}
      </p>
    </div>
  );
};
